import styled from 'styled-components';

interface IArticleSectionProps {
  children: React.ReactNode;
  hasImage?: boolean;
}

export const ArticleSection = ({ children, hasImage }: IArticleSectionProps) => {
  return <ArticleSection.Wrapper $hasImage={hasImage}>{children}</ArticleSection.Wrapper>;
};

ArticleSection.Wrapper = styled.section<{ $hasImage: boolean }>`
  margin: ${({ $hasImage }) => {
    if ($hasImage) {
      return '60px auto';
    }

    return '55px auto';
  }};

  a {
    text-decoration: underline;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    margin: ${({ $hasImage }) => ($hasImage ? '10em 0' : '5em 0')};
  }
`;
